import { defineComponent, ref, watch } from 'vue';
export default defineComponent({
  name: "Confirm",
  props: {
    show: {
      type: Boolean,
      "default": false
    },
    text: {
      type: String,
      "default": ""
    },
    options: {
      type: Object,
      "default": function _default() {
        return {
          showCancel: true,
          showConfirm: true,
          no: "Cancel",
          yes: "OK"
        };
      }
    }
  },
  emits: ['update:show', 'confirm', 'cancel'],
  setup: function setup(props, context) {
    var id = ref('asdsdnkcondifrmdd');

    var handlerClick = function handlerClick(e) {
      context.emit("update:show", false);

      if (e.target.classList.contains("confirm")) {
        context.emit("confirm");
      } else if (e.target.classList.contains("cancel")) {
        context.emit("cancel");
      }
    };

    watch(function () {
      return props.show;
    }, function (val) {
      val ? document.body.classList.add('mask-parent--hidden') : document.body.classList.remove('mask-parent--hidden');
    });
    return {
      id: id,
      handlerClick: handlerClick
    };
  }
});